<template>
  <v-layout column ref="mailing_view_layout">
    <v-toolbar dense ref="aToolbar" flat>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <!-- EXDEVBG-217 Allow any user to edit and save mailings - remove !mailing.item -->
        <!-- :disabled="mailing.item && (!mailing.own || mailing.status!=='open')" -->
        <v-btn text color="primary" :disabled="mailing.item && (mailing.status!=='open')" @click="onSave()"><v-icon>mdi-floppy</v-icon>&nbsp;{{ $t('GENERIC_SAVE') }}</v-btn><br /><!-- mdi-content-save-outline -->
        <v-btn text @click="onSaveAs()"><v-icon>mdi-floppy</v-icon>&nbsp;{{ $t('GENERIC_SAVEAS') }}</v-btn><br /><!-- mdi-content-save-settings-outline -->
        <v-btn text color="red darken-1" :disabled="mailing.item && (mailing.status!=='open')" @click="onDelete()"><v-icon>mdi-trash-can-outline</v-icon>&nbsp;{{ $t('GENERIC_DELETE') }}</v-btn><br />
        <v-btn text :disabled="!dirty" @click="editMailing(mailing.item || 'new')"><v-icon>mdi-close-box-outline</v-icon>&nbsp;{{ $t('GENERIC_DISCARD') }}</v-btn><br />
<v-btn v-if="isDebug" fab small color="grey lighten-3" class="btn-debug" @click="debug=!debug"><v-icon>mdi-bug-outline</v-icon></v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-card>

      <v-card-text>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="mailing.name"
                  :label="$t('MAILING_NAME')"
                  :disabled="mailing.status!=='open'"
                  @change="dirty=true"
                  :rules="[value => value.length <= 50 || 'Max 50 characters']"
                ></v-text-field>
                <v-text-field
                  v-if="mailing.campaign.name"
                  v-model="mailing.campaign.name"
                  :label="$t('CAMPAIGN_TITLE')"
                  :messages="`${formatDate(mailing.campaign.start_date)} - ${formatDate(mailing.campaign.end_date)}`"
                  disabled
                ></v-text-field>
                <v-text-field v-else value="---" :label="$t('CAMPAIGN_TITLE')" disabled></v-text-field>
                <v-text-field
                  v-model="mailing.owner.fullname"
                  :label="$t('MAILING_OWNER')"
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 text-xs-right>
                <v-btn
                  color="blue darken-1"
                  :disabled="!mailing.mail_template"
                  @click.stop="onRun()"
                >{{ $t('MAILING_TESTMAIL_BUTTON') }}&nbsp;<v-icon>mdi-play-circle-outline</v-icon></v-btn>
              </v-flex>
              <v-flex xs12>
                <span v-if="debug">{{ mailing }}</span>
                <v-sheet color="grey lighten-3">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-model="mailingStatus"
                          :label="$t('MAILING_STATUS')"
                          readonly
                          disabled
                          :prepend-icon="mailingStatusIcon"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 text-xs-right v-if="mailing.dispatch_datetime">
                        <v-btn
                          v-if="mailing.status==='open'"
                          text
                          @click="checkApprove()"
                          :disabled="approveInThePast"
                        >{{ $t('MAILING_APPROVE') }}</v-btn>
                        <v-btn
                          v-else-if="mailing.status==='released'"
                          text
                          @click="onRevoke()"
                          :disabled="approveInThePast"
                        >{{ $t('MAILING_REVOKE') }}</v-btn>
                        <v-text-field
                          v-else
                          :value="mailing.recipientsCount.all"
                          :label="$t('MAILING_STATUS_CLOSED_COUNT', [''])"
                          readonly
                          disabled
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-sheet>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  v-model="mailing.language"
                  :items="languages"
                  :label="$t('MAILING_LANGUAGE')"
                  :disabled="mailing.status!=='open'"
                  @change="onLanguageChange()"
                ></v-select>
              </v-flex>
              <v-flex xs5 sm2>

                <!--NEW DATE-->
                <v-menu
                    ref="menuDate"
                    v-model="date_picker"
                    :close-on-content-click="false"
                    :return-value.sync="dispatch_date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="dispatch_date"
                        :label="$t('MAILING_DISPATCH_DATE')"
                        prepend-icon="mdi-calendar"
                        readonly
                        :disabled="mailing.status!=='open'"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="dispatch_date_ISO"
                      :min="date_picker_min"
                      no-title
                      scrollable
                      @input="date_picker=false"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="date_picker = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.menuDate.save(dispatch_date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

              </v-flex>
              <v-flex xs5 sm2>

                <!--NEW TIME-->
                <v-menu
                    ref="menuTime"
                    v-model="time_picker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="dispatch_time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="dispatch_time"
                        :label="$t('MAILING_DISPATCH_TIME')"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        :disabled="mailing.status!=='open'"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                      v-if="time_picker"
                      v-model="dispatch_time_ISO"
                      full-width
                      format="24hr"
                      @click:minute="$refs.menuTime.save(dispatch_time)"
                  ></v-time-picker>
                </v-menu>

              </v-flex>
              <v-flex xs2 sm2>
                <v-btn
                  icon
                  :title="$t('MAILING_CLEAR_TIME_TT')"
                  :disabled="mailing.status!=='open'"
                  @click="onClearDispatchDateTime()"
                ><v-icon>mdi-close</v-icon></v-btn>
                <v-btn
                  text
                  color="primary"
                  :title="$t('MAILING_SEND_NOW_TT')"
                  :disabled="mailing.status!=='open'"
                  @click="onSetDispatchDateTime()"
                >{{ $t('MAILING_SEND_NOW') }}</v-btn>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="mailing.subject"
                  :label="$t('MAILING_SUBJECT')"
                  :disabled="mailing.status!=='open'"
                  @change="dirty=true"
                  :rules="[value => value.length <= 150 || 'Max 150 characters']"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="mailing.from"
                  :label="$t('MAILING_FROM')"
                  type="email"
                  :placeholder="$t('MAILING_EMAIL_PLACEHOLDER')"
                  :rules="rules.email"
                  :disabled="mailing.status!=='open'"
                  @change="dirty=true"
                ></v-text-field>
              </v-flex>
              <v-flex xs9>
                <v-text-field
                  v-if="mailing.mail_template"
                  :value="mailing.mail_template.title"
                  :label="$t('MAILING_TEMPLATE')"
                  readonly
                  :prepend-inner-icon="(mailing.mail_template.status === 'online') ? 'mdi-check-network-outline' : 'mdi-close-network-outline'"
                  :class="[ 'template-status', mailing.mail_template.status ]"
                  :color="(mailing.mail_template.status === 'online') ? 'success' : 'error'"
                  @click="selectTemplate = MAILING_TEMPLATES_FILTER"
                  @change="dirty=true"
                ></v-text-field>
                <v-text-field
                  v-else
                  :label="$t('MAILING_TEMPLATE')"
                  readonly
                  prepend-inner-icon="mdi-help-network-outline"
                  :disabled="mailing.status!=='open'"
                  @click="selectTemplate = MAILING_TEMPLATES_FILTER"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-btn
                  v-if="mailing.mail_template"
                  text
                  icon
                  :title="$t('TEMPLATE_SEARCH_BTN_NO_TEMPLATE')"
                  :disabled="mailing.status!=='open'"
                  @click="onDeselectTemplate(MAILING_TEMPLATES_FILTER)"
                ><v-icon>mdi-close</v-icon></v-btn>
                <v-btn
                  v-if="!mailing.mail_template"
                  text
                  :title="$t('MAILING_CHOOSE_TEMPLATE')"
                  :disabled="mailing.status!=='open'"
                  @click="selectTemplate = MAILING_TEMPLATES_FILTER"
                ><v-icon>mdi-dots-horizontal</v-icon>&nbsp;{{ $t('MAILING_CHOOSE_TEMPLATE') }}</v-btn>
                <v-btn
                  v-else
                  text
                  icon
                  :title="$t('MAILING_CHOOSE_TEMPLATE_TT')"
                  :disabled="mailing.status!=='open'"
                  @click="selectTemplate = MAILING_TEMPLATES_FILTER"
                ><v-icon>mdi-dots-horizontal</v-icon></v-btn>
                <v-btn
                  v-if="mailing.mail_template"
                  icon
                  :href="cmsUrl"
                  target="_blank"
                  :title="$t('MAILING_EDIT_TEMPLATE_TT')"
                  :disabled="mailing.status!=='open'"
                ><v-icon>mdi-square-edit-outline</v-icon></v-btn>
              </v-flex>
              <v-flex xs12 v-if="mailing.mail_template">
                <v-btn text :href="mailing.html_link" target="_blank" :title="$t('MAILING_PREVIEW_HTML_TT')"><v-icon>mdi-format-float-left</v-icon>&nbsp;{{ $t('MAILING_PREVIEW_HTML') }}</v-btn>
                <v-btn text :href="mailing.text_link" target="_blank" :title="$t('MAILING_PREVIEW_TEXT_TT')"><v-icon>mdi-format-align-justify</v-icon>&nbsp;{{ $t('MAILING_PREVIEW_TEXT') }}</v-btn>
                <v-btn text @click="templateGuide = true"><v-icon>mdi-comment-question-outline</v-icon>&nbsp;{{ $t('MAILING_TEMPLATE_GUIDE_BUTTON') }}</v-btn><!-- TODO: is this needed? -->
              </v-flex>
              <v-flex xs9>
                <v-text-field
                  v-if="mailing.unsubscribe_link"
                  :value="mailing.unsubscribe_link.title"
                  :label="$t('MAILING_UNSUBSCRIBE')"
                  readonly
                  :prepend-inner-icon="(mailing.unsubscribe_link.status === 'online') ? 'mdi-check-network-outline' : 'mdi-close-network-outline'"
                  :class="[ 'template-status', mailing.unsubscribe_link.status ]"
                  :color="(mailing.unsubscribe_link.status === 'online') ? 'success' : 'error'"
                  :disabled="mailing.status!=='open'"
                  @click="selectTemplate = MAILING_UNSUBSCRIBE_FILTER"
                  @change="dirty=true"
                ></v-text-field>
                <v-text-field
                  v-else
                  :label="$t('MAILING_UNSUBSCRIBE')"
                  readonly
                  prepend-inner-icon="mdi-help-network-outline"
                  :disabled="mailing.status!=='open'"
                  @click="selectTemplate = MAILING_UNSUBSCRIBE_FILTER"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-btn
                  v-if="mailing.unsubscribe_link"
                  text
                  icon
                  :title="$t('TEMPLATE_SEARCH_BTN_NO_TEMPLATE')"
                  :disabled="mailing.status!=='open'"
                  @click="onDeselectTemplate(MAILING_UNSUBSCRIBE_FILTER)"
                ><v-icon>mdi-close</v-icon></v-btn>
                <v-btn
                  v-if="!mailing.unsubscribe_link"
                  text
                  :title="$t('MAILING_CHOOSE_TEMPLATE')"
                  :disabled="mailing.status!=='open'"
                  @click="selectTemplate = MAILING_UNSUBSCRIBE_FILTER"
                ><v-icon>mdi-dots-horizontal</v-icon>&nbsp;{{ $t('MAILING_CHOOSE_TEMPLATE') }}</v-btn>
                <v-btn
                  v-else
                  text
                  icon
                  :title="$t('MAILING_CHOOSE_TEMPLATE_TT')"
                  :disabled="mailing.status!=='open'"
                  @click="selectTemplate = MAILING_UNSUBSCRIBE_FILTER"
                ><v-icon>mdi-dots-horizontal</v-icon></v-btn>
                <v-btn
                  v-if="mailing.unsubscribe_link"
                  icon
                  :href="cmsUrlUnsubscribe"
                  target="_blank"
                  :title="$t('MAILING_EDIT_TEMPLATE_TT')"
                  :disabled="mailing.status!=='open'"
                ><v-icon>mdi-square-edit-outline</v-icon></v-btn>
              </v-flex>
              <v-flex xs12>
                <v-sheet color="grey lighten-3">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-subheader>{{ $t('MAILING_RECIPIENTS') }}</v-subheader>
                      </v-flex>
                      <v-flex xs12>
                        <span v-if="debug">{{ searches }}</span>
                        <v-autocomplete
                          v-model="recipients"
                          :items="searches"
                          :placeholder="$t('MAILING_RECIPIENTS_SEARCH')"
                          multiple
                          hide-selected
                          return-object
                          :disabled="mailing.status!=='open'"
                          @input="onSelect"
                          ref="recipients"
                          menu-props="auto"
                        >
                          <template v-slot:selection="{}">
                            <!-- show nothing, we're listing the selected items below -->
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <!-- recipients -->
                        <span v-if="debug">{{ mailing.recipients }}</span>

                        <!-- <draggable
                        :list="mailing.recipients"
                        :group="{name:'recepient', put: ['dndsearch']}" @add="onDrop"> -->

                        <v-list>


                          <!-- :id="'s'+recipient.id" -->



                          <template
                             v-for="recipient in mailing.recipients"
                          >





                            <v-list-item :key="recipient.value"  dense>
                              <v-list-item-action>
                                <v-icon v-if="recipient.type==='group'">mdi-account-group-outline</v-icon>
                                <v-icon v-else>mdi-magnify</v-icon>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title v-text="recipient.text"></v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-btn
                                  icon
                                  :disabled="mailing.status!=='open'"
                                  @click="onRemove(recipient.value)"
                                ><v-icon>mdi-close</v-icon></v-btn>
                              </v-list-item-action>
                            </v-list-item>


                          </template>




                        </v-list>
                         <!-- </draggable> -->




                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-sheet>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  v-model="duplicates_NOTallowed"
                  :label="$t('MAILING_SEND_ONCE')"
                  :disabled="!mailing.recipients.length || mailing.status!=='open'"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 sm6>
                <v-btn
                  :disabled="!mailing.recipients.length"
                  :loading="recipientsCount.isLoading"
                  @click="countSearchRecipients()"
                >
                  <v-icon>mdi-counter</v-icon>&nbsp;{{ $t('MAILING_COUNT_RECIPIENTS_TT') }}
                </v-btn>
                <span v-if="recipientsCount.show">
                  <v-chip label outline :color="mailing.duplicates_allowed ? '' : 'primary'"><v-icon :title="$t('MAILING_COUNT_RECIPIENTS_UNIQUE_TT')">mdi-inbox</v-icon>{{ recipientsCount.unique }}</v-chip>
                  <v-chip label outline :color="mailing.duplicates_allowed ? 'primary' : ''"><v-icon :title="$t('MAILING_COUNT_RECIPIENTS_ALL_TT')">mdi-inbox-multiple</v-icon>{{ recipientsCount.all }}</v-chip>
                </span>
              </v-flex>
              <v-flex xs12 sm6 text-xs-right>
                <v-btn
                  color="blue darken-1"
                  :disabled="!mailing.mail_template"
                  @click.stop="onRun()"
                >{{ $t('MAILING_TESTMAIL_BUTTON') }}&nbsp;<v-icon>mdi-play-circle-outline</v-icon></v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

    </v-card>
    <Dialog ref="dialog" />

    <v-dialog
      v-model="showSaveDialog"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          {{$t('SAVEAS_DIALOG_NAME_TT')}}
        </v-card-title>
        <v-card-text>
          <v-alert
            :value="mailing.name==backMailing.name"
            border="bottom"
            color="pink darken-1"
            dark
          >
            {{ $t('SAVEAS_DIALOG_NAME_EXISTS') }}
          </v-alert>
           <v-text-field
            v-model="mailing.name"
            :label="$t('MAILING_NAME')"
           >
           </v-text-field>
          <v-autocomplete
            :label="$t('SAVEAS_DIALOG_CAMPAIGN')"
            v-model="mailing.folder_id"
            :items="getCampaigns.map(a => ({ value: a.folder_id, text: a.name })).sort((a, b) => ('' + a.text).localeCompare(b.text))"
            clearable
          >
          </v-autocomplete>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="mailing.name==backMailing.name"
            color="green darken-1"
            text
            @click="doSaveAs"
          >
            {{ $t('GENERIC_SAVE') }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="doClose"
          >
            {{ $t('GENERIC_CANCEL') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MailingViewTemplateDlg
      :visible="selectTemplate"
      @select="onSelectTemplate($event)"
      @deselect="onDeselectTemplate()"
      @cancel="selectTemplate = false"
      :lang_id="mailing.language"
    />

    <MailingViewTemplateGuideDlg
      :visible="templateGuide"
      :debug="debug"
      @success="snackbar.show({ text: $t('TEMPLATE_GUIDE_CLIPBOARD_OK_SB'), color: 'info' })"
      @error="snackbar.show({ text: $t('TEMPLATE_GUIDE_CLIPBOARD_ERROR_SB'), color: 'error' })"
      @close="templateGuide = false"
    />

    <Snackbar v-bind="snackbar" @close="snackbar.close()" />

    <v-dialog
      :value="testMailing.step"
      persistent
      scrollable
      max-width="620px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('TESTMAIL_HEADER') }}</span>
        </v-card-title>
        <v-card-text>

          <v-sheet v-show="testMailing.step === 1">
            <p>{{ $t('TESTMAIL_WIZARD_QUESTION') }}</p>
            <v-sheet color="grey lighten-3">
              <v-container grid-list-md>
                <h3>{{ $t('TESTMAIL_WIZARD_CONTACTS') }}</h3>
                <v-btn block @click="testMailing.step = 2">{{ $t('TESTMAIL_WIZARD_SAVED_SEARCH') }}</v-btn>
                <v-btn block @click="testMailing.step = 2">{{ $t('TESTMAIL_WIZARD_CONTACT_GROUP') }}</v-btn>
              </v-container>
            </v-sheet>
            <v-sheet color="grey lighten-3 mt-2">
              <v-container grid-list-md>
                <h3>{{ $t('TESTMAIL_WIZARD_ANY_ADDRESS') }}</h3>
                <v-btn block @click="testMailing.step = 3">{{ $t('TESTMAIL_WIZARD_TYPE_EMAILS') }}</v-btn>
                <v-btn block @click="testMailing.step = 3; testMailing.mails = $store.getters.getAccountById(user_id).email">{{ $t('TESTMAIL_WIZARD_TO_MYSELF') }}</v-btn>
              </v-container>
            </v-sheet>
          </v-sheet>

          <v-sheet v-show="testMailing.step === 2">
            <p>{{ $t('TESTMAIL_HINT_SEARCH') }}</p>
            <v-autocomplete
              v-model="testMailing.selection"
              :items="searches"
              :label="$t('TESTMAIL_TO_SEARCH')"
              :placeholder="$t('MAILING_RECIPIENTS_SEARCH')"
              clearable
              return-object
              menu-props="auto"
            >
            </v-autocomplete>
            <v-checkbox
              v-model="testMailing.prefix"
              :label="$t('TESTMAIL_PREVIEW_PREFIX')">
            </v-checkbox>
            <div class="text-xs-right">
              <v-btn :disabled="!canSendTest" color="primary" large @click="onSendPreview()">{{ $t('TESTMAIL_SEND') }}</v-btn>
            </div>
          </v-sheet>

          <v-sheet v-show="testMailing.step === 3">
            <p v-nl2br>{{ $t('TESTMAIL_HINT_TYPE_EMAIL') }}</p>
            <v-text-field
              v-show="testMailing.template.id"
              :value="testMailing.template.text"
              :label="$t('TESTMAIL_PREVIEW_CONTACT')"
              single-line
              readonly
              @click="testMailing.template.id = null"
            ></v-text-field>
            <QuickSearch v-show="!testMailing.template.id" :icon="false" :label="$t('TESTMAIL_PREVIEW_CONTACT')" :placeholder="$t('HEADER_QUICKSEARCH_LABEL')" @select="testMailing.template = $event" />
            <v-textarea
              :label="$t('TESTMAIL_TO_EMAIL')"
              v-model="testMailing.mails"
              rows="2"
              auto-grow
            ></v-textarea>
            <v-checkbox
              v-model="testMailing.prefix"
              :label="$t('TESTMAIL_PREVIEW_PREFIX')">
            </v-checkbox>
            <div class="text-xs-right">
              <v-btn :disabled="!canSendTest" color="primary" large @click="onSendPreview()">{{ $t('TESTMAIL_SEND') }}</v-btn>
            </div>
          </v-sheet>

          <v-sheet v-show="testMailing.step === 4">
            <p v-nl2br>{{ $t('TESTMAIL_DISPATCH_CONFIRMATION') }}</p>
            <v-container v-if="!testMailing.sent">
              <v-progress-linear indeterminate />
              <p>{{ $t('TESTMAIL_DISPATCHING') }}</p>
            </v-container>
            <v-container v-else>
              <p v-nl2br v-if="testMailing.num_sent !== null">{{ $moment().format('HH:mm:SS') }} {{ testMailing.num_sent }} {{ testMailing.num_sent === '1' ? $t('TESTMAIL_MAIL_SENT') : $t('TESTMAIL_MAILS_SENT') }}</p>
              <p v-nl2br v-if="testMailing.mail_ok !== null && testMailing.mail_ok !== '1'">{{ $t('TESTMAIL_MAILING_FAILED') }}</p>
            </v-container>
          </v-sheet>

        </v-card-text>
        <v-card-actions>
          <v-btn text v-if="testMailing.step > 1" @click="testMailing.step = 1">{{ $t('GENERIC_BACK') }}</v-btn>
          <v-btn text v-if="testMailing.step > 1 && testMailing.step < 4" @click="testMailing.clear()">{{ $t('TESTMAIL_CLEAR_INPUT') }}</v-btn>
          <v-spacer />
          <v-btn text @click="testMailing.step = 0">{{ $t('GENERIC_CLOSE') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal dialog - when dispatch date is in the past, warn the user -->
    <v-dialog
      :value="approveInThePast"
      scrollable
      max-width="800px"
      @input="addLink.close()"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('MAILING_DISPATCH_PAST') }}</span>
        </v-card-title>
        <v-card-text>

          {{ $t('MAILING_DISPATCH_PAST_CONFIRM') }}

        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="warning" 
            @click="onApprove()"
          >{{ $t('MAILING_DISPATCH_PAST_CONFIRM_YES') }}</v-btn>
          <v-btn
            color="" 
            @click="approveInThePast=false"
          >{{ $t('MAILING_DISPATCH_PAST_CONFIRM_NO') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';

import EventBus from '../event-bus'

import Dialog from './common/Dialog'
import Snackbar from '../components/common/Snackbar'
import MailingViewTemplateDlg from './MailingViewTemplateDlg'
import MailingViewTemplateGuideDlg from './MailingViewTemplateGuideDlg'
import { dateToISO } from '../helpers/filters'
import Mailing from '../services/Mailing'
import Search from '../services/Search'
import MailingModel from '../models/MailingModel'
import QuickSearch from './QuickSearch'
import Campaign from '../services/Campaign'
// import draggable from 'vuedraggable'


export default {
  name: 'MailingView',
  components: {
    Dialog,
    Snackbar,
    MailingViewTemplateDlg,
    MailingViewTemplateGuideDlg,
    QuickSearch,
    // draggable,
  },
  props: ['id', 'refToolbar'],
  data() {
    return {
      // constants reference SearchTemplateCommand.as:24
      MAILING_TEMPLATES_FILTER: '268',
      MAILING_UNSUBSCRIBE_FILTER: '379',

      date_picker: null,
      time_picker: null,
      selectTemplate : false,
      templateGuide : false,
      recipients: [],
      showSaveDialog: false,
      debug: false,
      dirty: false,
      rules: {
        required: value => !!value || 'Required.',
        email: [
          value => value.length <= 150 || 'Max 150 characters',
          value => {
            const pattern = /^((\s*".*"\s<?)?(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))>?)$/
            return !value || ( pattern.test(value) || 'Invalid e-mail.' )
          }
        ]
      },
      snackbar: {
        visible: false,
        color: null,
        text: null,
        timeout: null,
        action: {
          label: null,
          callback: null
        },
        show(args) {
          if (this.visible) {
            this.close()
            // call self in 100 ms
            setTimeout(() => {
              this.show(args)
            }, 100)
          } else {
            this.open(args)
          }
        },
        open({color, text, timeout, action}) {
          this.color = color
          this.text = text
          this.timeout = timeout
          this.action = action
          this.visible = true
        },
        close() {
          this.visible = false
        }
      },
      testMailing: {
        step: 0,
        selection: null,
        template: {id: null, text: null},
        mails: '',
        prefix: true,
        clear() {
          this.selection = null
          this.template = {id: null, text: null}
          this.mails = ''
          this.prefix = true
          this.reset()
        },
        sent: false,
        num_sent: null,
        mail_ok: null,
        reset() {
          this.sent = false
          this.num_sent = null
          this.mail_ok = null
        }
      },
      pollMailingInterval: null,
      approveInThePast: false,
      // approveOnSave: false,
    }
  },
  computed: {
    ...mapGetters([
      'campaignEntries',
      'isDebug',
      'user_id',
      'user',
      'data',
      'languages',
      'getSearches',
      'getAccountById',
      'getCampaignById',
      'mailing',
      'backMailing',
      'recipientsCount',
      'getCampaigns',
      'dndActive',
      'selectedCampaignFolder'
    ]),

    isRecipientsOpen() {
      return this.$refs.recipients && this.$refs.recipients.isMenuActive;
    },
    cmsUrl() {
      return this.$store.getters.appCmsUrl
        .replace('%ticket%', this.user.ticket)
        .replace('%oid%', this.mailing.mail_template.oid)
        .replace('%local_lang%', this.mailing.language)
    },
    cmsUrlUnsubscribe() {
      return this.$store.getters.appCmsUrl
        .replace('%ticket%', this.user.ticket)
        .replace('%oid%', this.mailing.unsubscribe_link.oid)
        .replace('%local_lang%', this.mailing.language)
    },
    date_picker_min() {
      return this.$moment().format('YYYY-MM-DD')
    },
    searches() {
      return this.getSearches
        .map(a => ({ id: a.id, name: a.name, type: a.type, value: a.id, text: a.name }))
        .sort((a, b) => ('' + a.text).localeCompare(b.text))
    },
    dispatch_date_ISO: {
      get() {
        return this.mailing.dispatch_datetime ? this.mailing.dispatch_datetime.substr(0, 10) : null
      },
      set(val) {
        if (!this.mailing.dispatch_datetime) {
          this.onSetDispatchDateTime()
        }
        this.mailing.dispatch_datetime = `${val} ${this.mailing.dispatch_datetime.substr(11, 5)}`
      }
    },
    dispatch_date: {
      get() {
        return this.mailing.dispatch_datetime ? this.$moment(this.mailing.dispatch_datetime).format(this.$t('LOCALE_DATE_FORMAT')) : ''
      },
      set() {
        // TODO: parse (via $moment?)
      },
    },
    dispatch_time_ISO: {
      get() {
        return this.mailing.dispatch_datetime ? this.mailing.dispatch_datetime.substr(11, 5) : null
      },
      set(val) {
        if (!this.mailing.dispatch_datetime) {
          this.onSetDispatchDateTime()
        }
        this.mailing.dispatch_datetime = `${this.mailing.dispatch_datetime.substr(0, 10)} ${val}`
      }
    },
    dispatch_time: {
      get() {
        return this.mailing.dispatch_datetime ? this.$moment(this.mailing.dispatch_datetime).format('HH:mm') : ''
      },
      set() {
      },
    },
    duplicates_NOTallowed: { // this is the opposite of duplicates_allowed
      get() {
        return !this.mailing.duplicates_allowed
      },
      set(val) {
        this.mailing.duplicates_allowed = !val
      },
    },
    canSendTest() {
      return (this.testMailing.step === 2 && this.testMailing.selection && this.testMailing.selection.id)
        || (this.testMailing.step === 3 && this.testMailing.template.id && this.testMailing.mails && this._validateEmails(this._normalizeEmails(this.testMailing.mails)))
    },
    mailingStatusNames() {
      return {
        'closed': this.$t('MAILING_STATUS_CLOSED'),
        'released': this.$t('MAILING_STATUS_RELEASED'),
        'sending': this.$t('MAILING_STATUS_SENDING'),
        'open': this.$t('MAILING_STATUS_OPEN'),
      }
    },
    mailingStatus: {
      get() {
        return this.mailingStatusNames[this.mailing.status]
      },
      set(val) {
        console.log('Change mailing.status: ', val)
      },
    },
    mailingStatusIcon() {
      let icon;
      switch (this.mailing.status) {
        case 'open':
          icon = 'mdi-email-open';
          break;
        case 'released':
          icon = 'mdi-email-check';
          break;
        case 'sending':
          icon = 'mdi-email-send';
          break;
        case 'closed':
          icon = 'mdi-email';
          break;
      }
      return icon;
    },
  },
  watch: {
    id(val) {
      this.editMailing(val);
    },
    mailing() {
      this.$nextTick(() => {
        this.dirty = false
      })
    },
    'mailing.dispatch_datetime'() {
      this.dirty = true
    },
    'mailing.mail_template'() {
      this.dirty = true
    },
    'mailing.recipients'(val) {
      this.recipients = val
      this.dirty = true
    },
    recipients(newVal, oldVal) {
      if (newVal.length !== oldVal.length) {
        this.recipientsCount.show = false
      }
    },
    selectedCampaignFolder(val) {
      if (!this.mailing.item) {
        this.setCampaign(this.mailing, val)
      }
    },
  },
  created() {
    EventBus.$on('addToMailing', this.addRecipient)
  },
  mounted() {
    this.$refs.mailing_view_layout.title = '';
    this.refToolbar.$el.parentElement.appendChild(this.$refs.aToolbar.$el)
    this.editMailing(this.id)
  },

  methods: {
    runMailPolling(msecs) {
// console.log('runMailPolling()', msecs);
      if (this.pollMailingInterval) {
        clearInterval(this.pollMailingInterval)
      }
      this.pollMailingInterval = setInterval( () => {
        this.pollMailing(this.mailing.item)
      }, msecs)
    },
    editMailing(id) {
      if (id && id !== 'new') {
        new Mailing(this.$api).load(id)
          .then(() => {
            if (this.mailing.status === 'released') {
              this.runMailPolling(60000);
            }
            if (this.mailing.status === 'sending') {
              this.runMailPolling(5000);
            }
            this.$refs.form.validate()
        })
      } else {
        // ---> (id === 'new')
        const mailing = new MailingModel()
        mailing.owner = this.$store.getters.getAccountById(this.user_id)
        mailing.status = 'open'
        mailing.language = this.user.cont_lang_id && this.user.cont_lang_id || this.languages[0].id
        if (this.selectedCampaignFolder && this.selectedCampaignFolder.id) {
          this.setCampaign(mailing, this.selectedCampaignFolder)
        }
        this.$store.commit('setMailing', mailing)
        this.$store.commit('setBackMailing', { ...mailing})
      }
    },
    pollMailing(id) {
      if (id && id !== 'new') {
        new Mailing(this.$api).load(id)
      } else {
        // ---> (id === 'new')
      }
    },
    setCampaign(mailing, folder) {
      if (folder) {
        mailing.folder_id = folder.id
        mailing.folder_name = folder.name
        const campaign = this.inCampaign(folder)
        if (campaign) {
          mailing.campaign.folder_id = campaign.id
          mailing.campaign.name = campaign.name
        } else {
          mailing.folder_name = ''
          mailing.campaign.name = ''
        }
      } else {
        mailing.folder_id = 0
        mailing.campaign.folder_id = 0
        mailing.folder_name = ''
        mailing.campaign.name = ''
      }
    },
    inCampaign(folder) {
      return !folder ? null : folder.datatype == 'campaign' ? folder : this.inCampaign(folder.parent)
    },
    onSelect(selected) {
      this.mailing.recipients = selected
    },
    onRemove(id) {
      this.mailing.recipients = this.mailing.recipients.filter(a => a.value !== id)
    },
    onClearDispatchDateTime() {
      this.mailing.dispatch_datetime = ''
    },
    onSetDispatchDateTime() {
      const d = new Date()
      this.mailing.dispatch_datetime = `${d.getFullYear()}-${(d.getMonth()+1).pad()}-${(d.getDate()).pad()} ${d.getHours().pad()}:${d.getMinutes().pad()}:00`
      //this.approveOnSave = true
      //this.onSave()
    },
    onCloseRecipients() {
      this.$refs.recipients.isMenuActive = false;
    },
    validateForm() {
      let reason = null
      if (!this.mailing.subject) {
        reason = 'MAILING_MISSING_SUBJECT'
      } else
      if (!this.mailing.from) {
        reason = 'MAILING_MISSING_SENDER'
      } else
      if (!this.mailing.mail_template) {
        reason = 'MAILING_MISSING_TEMPLATE'
      } else
      if (this.mailing.mail_template.status !== 'online') {
        reason = 'MAILING_MISSING_OFFLINE'
      } else
      if (!this.mailing.recipients.length) {
        reason = 'MAILING_MISSING_RECIPIENTS'
      } else
      if (!this.$refs.form.validate()) {
        reason = 'MAILING_MISSING_EMAIL_INVALID'
      }
      if (reason) {
        this.$store.commit('showMessage', {color: 'yellow', title: this.$t('MAILING_MISSING_FIELDS_TITLE'), content: (this.$t('EXTSEARCH_INVALID') + ' ' + this.$t(reason))})
      }
      return !reason
    },
    onLanguageChange() {
      this.dirty = true;
      this.mailing.mail_template = null
      this.mailing.unsubscribe_link = null
    },
    checkApprove() {
        // EXDEVBG-216 - [CRM BUG] Mailing with date / time "now" cannot be sent
      if (this.$moment(this.mailing.dispatch_datetime).add(120 , 'seconds').isBefore()) {
        this.approveInThePast = true;
        // this.snackbar.show({ text: this.$t('MAILING_DISPATCH_PAST_CONFIRM'), color: 'warning' })
      } else {
        this.onApprove();
      }
    },
    onApprove() {
      if (!this.mailing.item || this.dirty) {
        this.$store.commit('showMessage', {color: 'blue', title: this.$t('GENERIC_UNSAVED_CHANGES_TITLE'), content: this.$t('MAILING_NOT_SAVED')})
      } else if (this.validateForm()) {
        this.mailing.status = 'released'
        this.approveInThePast = false
        this.onSave()
      }
    },
    onRevoke() {
      if (this.mailing.status === 'released') {
        this.mailing.status = 'open'
        this.onSave()
      }
    },
    doClose() {
      this.showSaveDialog = false
    },
    onSaveAs() {
      // open Name Dialog, ask for a name
      this.showSaveDialog = true
    },
    doSaveAs() {
      if (this.mailing.name != this.backMailing.name) {
        this.mailing.item = null
        this.mailing.status = 'open'
        this.mailing.dispatch_datetime = ''
        this.onSave()
      }
    },
    onSave() {
      if (!this.mailing.name.trim()) {
        this.$store.commit('showMessage', {color: 'yellow', title: this.$t('MAILING_ENTER_NAME_TITLE'), content: this.$t('MAILING_ENTER_NAME')})
        return
      }
      this.$store.commit('setMailing', this.mailing)
      if (this.mailing.item) {
        new Mailing(this.$api).update()
        .then(() => {
          this.dirty = false
          if (this.pollMailingInterval) {
            clearInterval(this.pollMailingInterval)
          }
          if (this.mailing.status === 'released') {
            this.runMailPolling(60000);
          }
          if (this.mailing.status === 'sending') {
            this.runMailPolling(5000);
          }
          // if(this.approveOnSave){
          //   this.approveOnSave = false
          //   this.onApprove()
          // }
        })
      } else {
        new Mailing(this.$api).create()
        .then(() => {
          this.dirty = false
          this.doClose()
          this.$router.replace({name: 'mailing', params: {id: this.mailing.item, title: this.mailing.name}, hash: this.getNewHash()})
        })
      }
    },
    onRun() {
      if (this.dirty) {
        this.$store.commit('showMessage', {color: 'blue', title: this.$t('GENERIC_UNSAVED_CHANGES_TITLE'), content: this.$t('MAILING_NOT_SAVED')})
      } else {
        this.testMailing.step = 1
      }
    },
    onDelete() {
      this.$refs.dialog.show({
        type: '',
        title: this.$t('GENERIC_DELETE_ALERT_TITLE'),
        message: this.$t('NAVI_CONFIRM_DELETE_MAILING', [this.mailing.name]),
        buttons: [
          {
            label: this.$t('GENERIC_DELETE'),
            close: true,
            // default: true,
            danger: true,
            callback: () => {
              new Mailing(this.$api).delete(this.mailing.item)
              .then(() => {
                this.$router.push({ name: 'mailings', hash: this.getNewHash()}) // go back Home
                new Campaign(this.$api).list_entries()
              })
            }
          },
          {
            label: this.$t('GENERIC_CANCEL'),
            close: true,
          },
        ]
      })
    },
    addRecipient(item) {
      if (this.mailing.status === 'open') {
        if (!this.mailing.recipients.filter(a => a.id===item.id).length) {
          this.mailing.recipients.push(this.searches.find(a => a.id === item.id))
        }
      }
    },
    formatDate(val) {
      return this.$moment(dateToISO(val)).format(this.$t('LOCALE_DATE_FORMAT'))
    },
    onSelectTemplate(template) {
      if (this.selectTemplate === this.MAILING_TEMPLATES_FILTER) {
        this.mailing.mail_template = template
      } else {
        this.mailing.unsubscribe_link = template
      }
      if (!this.mailing.language) {
        this.mailing.language = this.user.cont_lang_id
      }
      this.selectTemplate = false
    },
    onDeselectTemplate(filter) {
      if (this.selectTemplate === this.MAILING_TEMPLATES_FILTER || filter === this.MAILING_TEMPLATES_FILTER) {
        this.mailing.mail_template = null
      } else {
        this.mailing.unsubscribe_link = null
      }
      this.selectTemplate = false
    },
    countSearchRecipients() {
      new Search(this.$api).count(this.mailing.recipients.map(a => a.id))
    },
    onLeave(next) {
      if (this.dirty) {
        this.$refs.dialog.show({
          type: '',
          title: this.$t('GENERIC_UNSAVED_CHANGES_TITLE'),
          message: this.$t('GENERIC_UNSAVED_CHANGES'),
          buttons: [
            {
              label: this.$t('GENERIC_SAVE'),
              close: true,
              default: true,
              callback: () => {
                this.onSave()
                next()
              },
            },
            {
              label: this.$t('GENERIC_DISCARD'),
              close: true,
              default: true,
              callback: () => {
                next()
              },
            },
            {
              label: this.$t('GENERIC_CANCEL'),
              close: true,
            },
          ]
        })
      } else {
        next()
      }
    },
    appReload(e) {
      if (this.dirty) {
        e.preventDefault()
        e.returnValue = 'Please save' // Chrome only
        return 'Please save' // legacy
      }
    },
    onSendPreview() {
      const params = {
        id: this.mailing.item,
        preview_subject_prefix: +this.testMailing.prefix
      }
      if (this.testMailing.step === 2) {
        params['preview_query_id'] = this.testMailing.selection.id
      } else
      if (this.testMailing.step === 3) {
        params['preview_aid'] = this.testMailing.template.id
        params['mailto'] = this._normalizeEmails(this.testMailing.mails)
      }
      this.testMailing.reset()
      this.testMailing.step = 4
      new Mailing(this.$api).send_preview(params)
        .then(result => {
          this.testMailing.num_sent = result._attributes.num_send
          this.testMailing.mail_ok = result._attributes.mail_ok
          this.testMailing.sent = true
        }, () => {
        });
    },
    _normalizeEmails(mails) {
      return mails
        .replace(/(?:\r\n|\r|\n)/g, ',')
        .split(',')
        .map(a => a.trim())
        .filter(Boolean)
        .join(',')
    },
    _validateEmails(mails) {
      mails = mails.split(',')
      const pattern = /^((\s*".*"\s<?)?(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))>?)$/
      return mails.length === mails.filter(a => pattern.test(a) === true).length
    },
    getNewHash() {
      const dt = new Date()
      return '##'+ (dt.getTime()*1000 + dt.getMilliseconds())
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.onLeave(next)
  },
  beforeRouteLeave(to, from, next) {
    this.onLeave(next)
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.appReload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.appReload)
    this.$refs.aToolbar.$el.remove()
    EventBus.$off('addToMailing', this.addRecipient)
    if (this.pollMailingInterval) clearInterval(this.pollMailingInterval);
  },
}
</script>

<style scoped lang="scss">
.container {
  padding: 12px;
}
.v-card__title {
  position: relative;
}
.v-text-field.template-status {
  &.online {
    .v-input__icon--prepend-inner .v-icon {
      color: #4caf50; // success--text
    }
  }
  &.offline {
    .v-input__icon--prepend-inner .v-icon {
      color: #ff5252; // error--text
    }
  }
}
.in-the-past {
  background: #f49017;
  display: inline-block;
}
#recipientsCount {
  color: rgba(0, 0, 0, 0.87) !important;
  .unique {
    font-weight: 600;
  }
  .all {
    font-weight: 300;
  }
  &.duplicates_allowed {
    .unique {
      font-weight: 300;
    }
    .all {
      font-weight: 600;
    }
  }
}
</style>

